import basic from './basicComponents/index'
import biz from './bizComponents/index'

import './style/index.scss'
import { valid, fn, baseStorage } from './utils'
// export default {...basic,...biz}
const namespace = 'srd'
const components = { ...basic, ...biz }
const install = function (Vue) {
    // eslint-disable-next-line no-debugger
    // 遍历注册全局组件
    Object.keys(components).map(e => {
        Vue.component(namespace + '-' + e, components[e]);
    });
    Vue.prototype.$fn = fn
    Vue.prototype.$baseStorage = baseStorage
    Vue.prototype.$valid = valid
}
/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}
export default {
    install
}